function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0,0H18V18H0Z",
  fill: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.414,12.231a5.119,5.119,0,0,0,0-1.463L19,9.527a.374.374,0,0,0,.09-.48l-1.5-2.6a.371.371,0,0,0-.457-.161l-1.868.754A5.691,5.691,0,0,0,14,6.3l-.281-1.988A.386.386,0,0,0,13.341,4h-3a.379.379,0,0,0-.371.315L9.689,6.3a5.55,5.55,0,0,0-1.267.739L6.554,6.287a.375.375,0,0,0-.458.161l-1.5,2.6a.376.376,0,0,0,.09.48l1.583,1.241a5.119,5.119,0,0,0,0,1.463L4.686,13.473a.374.374,0,0,0-.09.48l1.5,2.6a.371.371,0,0,0,.457.161l1.868-.754a5.691,5.691,0,0,0,1.268.739l.281,1.987a.379.379,0,0,0,.371.315h3a.379.379,0,0,0,.371-.315l.281-1.987a5.55,5.55,0,0,0,1.267-.739l1.868.754a.375.375,0,0,0,.457-.161l1.5-2.6a.376.376,0,0,0-.09-.48Zm-5.573,1.894A2.625,2.625,0,1,1,14.466,11.5,2.623,2.623,0,0,1,11.841,14.125Z",
  transform: "translate(-2.841 -2.5)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "storage/static/media/settings-icon.9bd648d4.svg";
export { SvgComponent as ReactComponent };